import { FC, ReactNode } from "react"
import { cn } from "../../../utils"

interface Props {
  icon: ReactNode
  iconClassName?: string
  title: string
  description: string
  children: ReactNode
}

const ConfigToolCard: FC<Props> = ({
  icon,
  iconClassName,
  title,
  description,
  children
}) => (
  <div className="bg-white border border-neutral-200 rounded-lg">
    <div className="px-6 py-5 border-b border-neutral-100 bg-neutral-50 rounded-t-lg">
      <div className="flex items-center gap-3">
        <div
          className={cn(
            "w-10 h-10 rounded-lg flex items-center justify-center",
            iconClassName
          )}
        >
          {icon}
        </div>
        <div>
          <h3 className="text-base font-semibold text-gray-900">{title}</h3>
          <p className="text-sm text-gray-500">{description}</p>
        </div>
      </div>
    </div>
    {children}
  </div>
)

export default ConfigToolCard
